"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgIconShareable = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgIconShareable = function SvgIconShareable(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.45015 3.32233C1.45015 2.0418 2.43272 1 3.64048 1C4.84826 1 5.83083 2.0418 5.83083 3.32233C5.83083 4.60286 4.84823 5.64466 3.64048 5.64466C2.43272 5.64466 1.45015 4.60286 1.45015 3.32233ZM8.60536 1.33237L8.62027 1.33232C9.65032 1.33232 10.493 2.21477 10.502 3.30681C10.5064 3.83381 10.3179 4.33202 9.97132 4.70967C9.61854 5.09409 9.1451 5.30812 8.63824 5.31231L8.6231 5.31236C8.12187 5.31236 7.65089 5.10653 7.29534 4.73174C6.94259 4.35984 6.74592 3.86481 6.74156 3.33785C6.73723 2.81088 6.92569 2.31267 7.27228 1.93502C7.62506 1.55057 8.0985 1.33656 8.60536 1.33237ZM8.71266 5.69256H8.53078C7.81279 5.69256 7.14801 5.92395 6.60669 6.31592C6.45496 6.42578 6.46464 6.64719 6.60295 6.77352C6.65082 6.81725 6.69781 6.86217 6.74391 6.90826C7.1325 7.29686 7.43766 7.74967 7.65094 8.25405C7.78118 8.56187 7.87354 8.88089 7.92749 9.20797C7.9708 9.47051 8.18703 9.67975 8.45312 9.67975H11.5C11.7761 9.67975 12 9.45589 12 9.17975V8.97967C12 7.16725 10.5253 5.69256 8.71266 5.69256ZM5.8575 7.06905C6.66586 7.67139 7.2075 8.61123 7.27383 9.67975C7.27852 9.75334 7.28086 9.82764 7.28086 9.9024C7.28086 10.1338 7.09324 10.3215 6.8618 10.3215H0.419063C0.187621 10.3215 0 10.1338 0 9.9024C0 7.95217 1.58086 6.37133 3.53109 6.37131H3.75C4.54008 6.37131 5.26945 6.63076 5.8575 7.06905Z",
    fill: "currentColor"
  }));
};

exports.SvgIconShareable = SvgIconShareable;